export enum OrderPaymentMethodsEnum {
    THIRD_PARTY_FINANCING = "thirdPartyFinancing",
    BITPAY = "bitPay",
    PAY_WITH_CASH = "payWithCash",
    CAR_OR_LEASE_PAYMENT = "carOrLeasePayment",
    CAR_LEASE = "carLease",
    CAR_LOAN = "carLoan",
    LONG_TERM_CAR_LOAN = "longTermCarLoan",
}
